import { Alert } from "@mui/material";

import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import VehicleOperations, {
  VehicleOperationsTabs,
} from "@/common/components/EntityComposed/Operations/VehicleOperations";
import { ViewVariant } from "@/common/ts/layout";
import { DamageDetectionDto } from "@/core/api/generated/v1";

interface Props {
  damageDetection: DamageDetectionDto;
}

export default function RelatedOperationsTabContent({ damageDetection }: Props) {
  return (
    <PageTabContent gap={0}>
      <Alert severity='info'>
        Here you can see related operations. For instance, operations for the same damages or
        operations that are in the same context.
      </Alert>

      <VehicleOperations
        vehicleId={damageDetection.vehicle?.id}
        anyVehicleDamageIds={damageDetection.items
          ?.map((x) => x.damage?.id || "")
          .filter((x) => !!x)}
        displayProps={{
          header: false,
          filters: false,
          viewVariant: ViewVariant.Tab,
        }}
        excludeTabs={[
          VehicleOperationsTabs.DamageDetections,
          VehicleOperationsTabs.AccessoryChecks,
        ]}
      />
    </PageTabContent>
  );
}
